(function () {

  const players = [];

  function initYouTubePlayers() {

    const iframes = document.querySelectorAll('iframe.js-embed-player');

    if (!iframes || iframes.length === 0) return;

    iframes.forEach((iframe, index) => {
      if (iframe.dataset.ytInitialized) return;
      if (!iframe.src || !iframe.src.includes('enablejsapi=1')) return;

      players[index] = new YT.Player(iframe, {
        events: {
          onReady: e => e.target.playVideo(),
          onStateChange: onPlayerStateChange
        }
      });

      iframe.dataset.ytInitialized = 'true';
    });
  }

  function onPlayerStateChange(event) {
    if (event.data === YT.PlayerState.ENDED) {
      event.target.seekTo(0);
      event.target.playVideo();
    }
  }

  window.onYouTubeIframeAPIReady = function () {
    initYouTubePlayers();
  };

  if (!window.YT) {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    document.head.appendChild(tag);
  } else if (window.YT && window.YT.Player) {
    initYouTubePlayers();
  }
})();
